import { useEffect, useState } from 'react';
import QRCodeLib from 'qrcode';

/**
 * Generates a QR code as a PNG data URL on the client. Used by the
 * detail-page heroes to feed `<DetailPageHero image={{ url }}>` —
 * since the shared component takes a URL string, we precompute the
 * data URL rather than rendering a custom React node into the slot.
 *
 * Returns `null` while the encoding is in flight or if `value` is
 * empty so callers can fall back to a placeholder/icon.
 */
export function useQrDataUrl(value: string | null | undefined, size = 256): string | null {
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!value) {
      setDataUrl(null);
      return;
    }
    let cancelled = false;
    QRCodeLib.toDataURL(value, {
      width: size,
      margin: 1,
      errorCorrectionLevel: 'M',
    })
      .then((url) => {
        if (!cancelled) setDataUrl(url);
      })
      .catch(() => {
        if (!cancelled) setDataUrl(null);
      });
    return () => {
      cancelled = true;
    };
  }, [value, size]);

  return dataUrl;
}
